import { useMemo } from 'react'

import { styled } from 'styled-components'

import type { ContractDto } from '@b-stock/contract-api-client'
import type { BidPrecision } from '@b-stock/fe-core/bstock-next/hooks'
import { Table } from '@b-stock/fe-core/bstock-react'
import { designColors } from '@b-stock/fe-core/theme'

import type { OfferingItemRow } from '../types'
import { getColumns } from './getColumns'
import { getContractColumns } from './getContractColumns'

const TableBorder = styled.div`
  border: 1px solid ${designColors.neutral.mediumGray};
  border-width: 0 1px 1px;
`

export const OfferingFormTable = ({
  bidPrecision,
  contract,
  currency = 'USD',
  rows,
}: {
  bidPrecision: BidPrecision
  contract?: ContractDto | null
  currency?: string
  rows: OfferingItemRow[]
}) => {
  const quantityUnits = rows[0]?.item.quantityUnits ?? 'ITEM'

  const columns = useMemo(
    () =>
      contract
        ? getContractColumns({ bidPrecision, contract, currency })
        : getColumns({ bidPrecision, currency, quantityUnits }),
    [bidPrecision, contract, currency, quantityUnits]
  )

  return (
    <TableBorder>
      <Table columns={columns} data={rows} total={rows.length} />
    </TableBorder>
  )
}
